import styled from "styled-components";
import { COLORS, FontFamilyTypeEnum, Z_INDEX } from "../styled";

export const SaveOrShareOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${COLORS.BLACK_BACKGROUND_OPACITY_80};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${Z_INDEX.HIGHEST + 1};
  padding: max(12px, env(safe-area-inset-top, 0px)) max(12px, env(safe-area-inset-right, 0px))
    max(12px, env(safe-area-inset-bottom, 0px)) max(12px, env(safe-area-inset-left, 0px));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
`;

export const SaveOrShareCard = styled.div`
  background: ${COLORS.WHITE};
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  max-width: 360px;
  width: 100%;
  max-height: calc(100vh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
  max-height: calc(100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  margin: auto;
  flex-shrink: 0;
`;

export const SaveOrShareHeader = styled.div<{ $teamColor?: string }>`
  background: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  padding: 16px 20px;
  text-align: center;
  flex-shrink: 0;
`;

export const SaveOrSharePreview = styled.div`
  padding: 10px 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${COLORS.WHITE};
  flex-shrink: 0;
`;

export const SaveOrSharePreviewImage = styled.img`
  max-width: 100%;
  max-height: clamp(72px, 22vh, 200px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid ${COLORS.GREY_LIGHT};
`;

export const SaveOrShareHashtagPromo = styled.p`
  margin: 0;
  padding: 8px 20px 0;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.GREY_TEXT};
  text-align: center;
  letter-spacing: 0.02em;
  flex-shrink: 0;
`;

export const SaveOrShareBulkNote = styled.p`
  margin: 0;
  padding: 6px 20px 0;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
  color: ${COLORS.GREY_TEXT};
  text-align: center;
  flex-shrink: 0;
`;

export const SaveOrShareTitle = styled.h2`
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.WHITE};
  margin: 0;
  line-height: 1.3;
`;

export const SaveOrShareBody = styled.div`
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const SaveOrShareButton = styled.button<{ $variant?: "primary" | "secondary" | "outline"; $teamColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;

  ${({ $variant, $teamColor }) => {
    const color = $teamColor || COLORS.BLUE_MAIN;
    if ($variant === "primary") {
      return `
        background: ${color};
        color: ${COLORS.WHITE};
        border-color: ${color};
        img, svg { filter: brightness(0) invert(1); }
      `;
    }
    if ($variant === "outline") {
      return `
        background: transparent;
        color: ${COLORS.BLACK_MAIN};
        border-color: ${COLORS.GREY_LIGHT};
        &:hover { border-color: ${color}; background: rgba(0,0,0,0.02); }
      `;
    }
    return `
      background: ${COLORS.GREY_MAIN};
      color: ${COLORS.BLACK_MAIN};
      border-color: ${COLORS.GREY_LIGHT};
      &:hover { background: ${COLORS.GREY_LIGHT}; }
    `;
  }}

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const SaveOrShareIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  img, svg {
    width: 24px;
    height: 24px;
  }
`;

export const SaveOrShareCancel = styled.button`
  margin-top: 8px;
  padding: 12px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.GREY_TEXT};
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;

  &:hover {
    background: ${COLORS.GREY_MAIN};
    color: ${COLORS.BLACK_MAIN};
  }
`;
